import React, { useEffect } from "react";
import { Navigate } from "react-router-dom";

const DynamicRedirect: React.FC = () => {
  const sessionType = localStorage.getItem('sessionType');
  
  // If no session type is stored, default to dashboard
  if (!sessionType) {
    return <Navigate to="/dashboard" replace />;
  }

  // Route based on session type
  if (sessionType === 'derivative') {
    return <Navigate to="/derivative" replace />;
  } else {
    return <Navigate to="/dashboard" replace />;
  }
};

export default DynamicRedirect;
